export const INSPECTION_WARNING_THRESHOLD_KM = 3000;
